// Customers mutations
import types from '../../types';
import date from '../../../mixins/date'

export default {
  [types.STORE_REPORTS]: (state, payload) => {
    state.adminReports = payload;
    state.adminReports.items.map((item) => {
      const newItem = item;
      newItem.created_at = date.methods.formatDate(item.created_at, 'DD.MM.YYYY');
      return newItem;
    })
  },
  [types.CLEAR_REPORTS]: (state) => {
    state.adminReports = {
      items: [],
      count: '',
      entity: {},
    };
  },
};
